// extracted by mini-css-extract-plugin
export default {"container":"TrufflePage_container__iTAR7","price":"TrufflePage_price__AaChc"};